/**
 * These are the fields for each resource type that are used to filter the search
 */
export default {
  OFFERS: ["short_title", "description", "program_name"],
  BRANDS: ["name", "description"],
  CAFES: ["name", "description"],
  ARTICLES: ["title", "blurb"],
}
